module.exports = __webpack_public_path__ + "media/images/icons/flags/ZA-bf75074160cfb34b1bb054032b71f60c.svg";